var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"photos-grid",attrs:{"role":"grid","name":"list","tag":"div"}},[_vm._t("default"),_vm._v(" "),_c('div',{key:"footer",staticClass:"photos-grid__footer-spacer",attrs:{"role":"none"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }